import { render, staticRenderFns } from "./CustomerWebhooks.vue?vue&type=template&id=267c994b"
import script from "./CustomerWebhooks.vue?vue&type=script&lang=js"
export * from "./CustomerWebhooks.vue?vue&type=script&lang=js"
import style0 from "./CustomerWebhooks.vue?vue&type=style&index=0&id=267c994b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports